<template>
  <main>
    <router-view />
  </main>
</template>

<script>

import { isRouteMatch } from '@/util'

export default {
  props: {
    routeName: String,
    defaultRouteName: String,
    defaultRouteParams: Object
  },
  created () {
    this.ensureRoute()
  },
  watch: {
    '$route' () {
      this.ensureRoute()
    }
  },
  methods: {
    ensureRoute () {
      if (this.routeName && this.defaultRouteName) {
        if (isRouteMatch(this.$route, this.routeName)) {
          this.$router.push({ name: this.defaultRouteName, params: this.defaultRouteParams })
        }
      }
    }
  }
}
</script>
